import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

// Common Provider component
export const CommonProvider = ({ children }) => {
   // SnackConfig state
   const [snackConfig, setSnackConfigState] = useState({
      open: false,
      message: "",
      severity: "success",
      timeout: 4000,
      bgColor: 'var(--brand-color)',
   });

   const setSnackConfig = (config) => {
      setSnackConfigState((prev) => ({ ...prev, ...config }));
   };

   const value = {
      snackConfig,
      setSnackConfig,
   };

   return (
      <AppContext.Provider value={value}>
         {children}
      </AppContext.Provider>
   );
};

// Custom hook to use the context (for functional components)
export const useApp = () => {
   const context = useContext(AppContext);
   if (!context) {
      throw new Error('useApp must be used within a AppProvider');
   }
   return context;
};

export default AppContext;